import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

export default function CleaningBusinessSuccess() {
  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "120px auto",
        background: "#fff",
        padding: "40px",
        borderRadius: "12px",
        textAlign: "center",
        boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
      }}
    >
      <FaCheckCircle size={80} color="#2e7d32" />

      <h1 style={{ color: "#2e7d32", marginTop: "20px" }}>
        Cleaning Business Listed Successfully!
      </h1>

      <p style={{ fontSize: "1.05rem", color: "#555", marginTop: "10px" }}>
        Your cleaning business is now live and accepting enquiries.
      </p>

      <div style={{ marginTop: "30px" }}>
        <Link to="/cleaning/business">
          <button
            style={{
              background: "#2e7d32",
              color: "#fff",
              padding: "12px 20px",
              marginRight: "10px",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            View Cleaning Businesses
          </button>
        </Link>

        <Link to="/cleaning/business/create">
          <button
            style={{
              background: "#555",
              color: "#fff",
              padding: "12px 20px",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Create Another
          </button>
        </Link>
      </div>
    </div>
  );
}
